import area from "@turf/area";
import { AllGeoJSON } from "@turf/helpers";
import {
  AreaTypes,
  ImperialArea,
  ImperialPerimeter,
  MetricArea,
  MetricPerimeter,
  PerimeterTypes,
} from "react-migration/lib/util/MeasurementTypes";
import {
  metersToFeet,
  squareMetersToAcres,
  squareMetersToHectares,
  squareMetersToSquareFeet,
} from "react-migration/lib/util/conversion";
import { format, formatToUnit } from "react-migration/lib/util/numberFormat";
import { length } from "src/js/util/turf";

export const calculateArea = (geometry: AllGeoJSON, areaType: AreaTypes): string => {
  const areaInSquareMeters = area(geometry);

  // Intl.NumberFormat currently doesn't support squared-meters or squared-feet,
  // so we will have to grow this util to work with different locales
  switch (areaType) {
    case ImperialArea.SQ_FEET:
      return `${format(squareMetersToSquareFeet(areaInSquareMeters))} sq. ft`;
    case ImperialArea.ACRE:
      return `${format(squareMetersToAcres(areaInSquareMeters))} ac`;
    case MetricArea.HECTARE:
      return `${format(squareMetersToHectares(areaInSquareMeters))} ha`;
    default:
      return `${format(areaInSquareMeters)} sq. m`;
  }
};

export const calculatePerimeter = (geometry: AllGeoJSON, perimeterType: PerimeterTypes): string => {
  // standard in meters as they don't support feet
  switch (perimeterType) {
    case ImperialPerimeter.FEET:
      return formatToUnit(metersToFeet(length(geometry, { units: "meters" })), "foot");
    case ImperialPerimeter.MILES:
      return formatToUnit(length(geometry, { units: "miles" }), "mile");
    case MetricPerimeter.KILOMETER:
      return formatToUnit(length(geometry, { units: "kilometers" }), "kilometer");
    default:
      return formatToUnit(length(geometry, { units: "meters" }), "meter");
  }
};
